const store = {
  collapseBoxes: {
    byId: {},
    allIds: []
  },
  dismissMissingFilogixDetailsBanner: {}
};
export default store;